<div
  class="email"
  [class.email--with-locked]="lockedLabels.length > 0"
  data-cy="email"
>
  @for (label of lockedLabels; track label) {
    <qima-chip
      class="email__locked-chip"
      data-cy="email-locked-chip"
      [qimaChipLabel]="label"
      [qimaChipHasCloseButton]="isLockedLabelsRemovableState"
      [qimaChipIsDisabled]="isDisabledState"
      (qimaChipClose)="onLockedLabelRemove(label)"
    >
      <qima-avatar
        [qimaAvatarFirstName]="label"
        [qimaAvatarSize]="avatarSize.MIN"
      ></qima-avatar>
    </qima-chip>
  }
  <qima-input-multiple-email
    class="email__input"
    [formControl]="emails"
    [qimaInputMultipleEmailPlaceholder]="placeholder"
    [qimaInputMultipleEmailHasValidators]="hasValidatorsState"
    [qimaInputMultipleEmailIsDisabled]="isDisabledState"
    [qimaInputMultipleEmailAcceptEmail]="acceptEmail"
    (ngModelChange)="onEmailsChange($event)"
    (qimaInputMultipleEmailValueRefused)="valueRefused($event)"
  ></qima-input-multiple-email>
</div>
